import { Box } from '@mui/material';
import React from 'react';
import { HeroMetricCard } from 'src/components/atlas/molecules';
import {
  DisclosureMetrics,
  MetricCardId,
} from 'src/components/pages/CoiDisclosures/types';
import * as styles from './DisclosuresHeroMetrics.styles';

export interface DisclosuresHeroMetricsProps {
  metrics: DisclosureMetrics;
  activeCard: MetricCardId | null;
  onCardClick: (id: MetricCardId) => void;
}

const CARDS: { id: MetricCardId; label: string; tooltip: string }[] = [
  {
    id: 'assigned',
    label: 'Disclosures assigned to you',
    tooltip: 'Disclosure assigned to the current user',
  },
  {
    id: 'actions',
    label: 'Actions needed',
    tooltip:
      'Disclosures assigned to the current user and with status "New" or "Under Review"',
  },
  {
    id: 'waiting',
    label: 'Waiting for response',
    tooltip:
      'Disclosures assigned to the current user with status "Pending Mitigation" or "Overdue Mitigation"',
  },
];

export const DisclosuresHeroMetrics: React.FC<DisclosuresHeroMetricsProps> = ({
  metrics,
  activeCard,
  onCardClick,
}) => (
  <Box sx={styles.container}>
    {CARDS.map((card) => (
      <HeroMetricCard
        key={card.id}
        data-testid={`hero-metric-card-${card.id}`}
        label={card.label}
        infoTooltip={card.tooltip}
        count={metrics[card.id]}
        isLoading={metrics.isLoading}
        selected={activeCard === card.id}
        onClick={() => onCardClick(card.id)}
      />
    ))}
  </Box>
);
